if (!customElements.get("collection-pdp-loader")) {
  let skipPdpLoaderHandler = false;

  function syncAftershipProductId(originalProductId) {
    if (!originalProductId) return;
    document.querySelectorAll('aftership-aedd').forEach(item => {
      if (item.getAttribute('product-id') !== originalProductId) {
        item.setAttribute('product-id', originalProductId);
      }
    });
  }

  class CollectionPdpLoader extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      this.products = this.querySelectorAll('.gg-product');
      this.currentActiveClass = null;
      this.currentActiveFilter = null;
      this.products.forEach(product => {
        product.addEventListener('click', () => {
          if (! product.dataset.productId || product.dataset.productId <= 0) {
            return;
          }

          if (skipPdpLoaderHandler) {
            return;
          }

          document.querySelectorAll('.gg-product.color-select.active').forEach(el => {
            el.classList.remove('active');
          });

          const activeProducts = document.querySelectorAll(`#${product.id}`);

          activeProducts.forEach(activeProduct => {
            activeProduct.classList.add('active');
          });

          this.currentActiveClass = product;

          // update the price for the selected item
          if (document.querySelector('.price-container')) {
            document.querySelectorAll('.price-container').forEach(priceContainer => {
              if (! priceContainer.querySelector('.price-area')) {
                return;
              }
              var price = priceContainer.querySelector('.price-area');
              var priceParent = price.parentElement;
              // the variant price is available
              if (priceContainer.querySelector('[data-variant-id="' + product.dataset.productId + '"]')) {
                priceParent.removeChild(price);
                priceParent.innerHTML += priceContainer.querySelector('[data-variant-id="' + product.dataset.productId + '"]').innerHTML;
                setTimeout(function() {
                  if (window.item) {
                      var _learnq = window._learnq || [];
                      // NOTE: The Klaviyo "Added to Cart" tracking (window.fetch wrapper +
                      // add-to-cart button listeners) is already set up exactly once on
                      // `window load` in gg-product-pdp.liquid. It used to be duplicated here,
                      // which re-wrapped window.fetch on every color swap. The stacked wrappers
                      // matched any response whose `res.url` was '' (''.includes is always true)
                      // and each fired a `/cart.js` request — producing dozens of redundant
                      // cart calls per swap. Removed; only the per-variant "Viewed Product"
                      // tracking below should run on a color change.

                    window.item = {
                      Name: product.dataset.productTitle,
                      ProductID: product.dataset.productId,
                      Categories: product.dataset.productFabricType,
                      ImageURL: product.dataset.productImageUrl,
                      URL: product.dataset.productFullUrl,
                      Brand: "Nugget",
                      Price: product.dataset.productPrice,
                      CompareAtPrice: product.dataset.productCompareAtPrice
                    };
                    _learnq.push(['track', 'Viewed Product', item]);
                    _learnq.push(['trackViewedItem', {
                      Title: item.Name,
                      ItemId: item.ProductID,
                      Categories: item.Categories,
                      ImageUrl: item.ImageURL,
                      Url: item.URL,
                      Metadata: {
                        Brand: item.Brand,
                        Price: item.Price,
                        CompareAtPrice: item.CompareAtPrice
                      }
                    }]);
                  }
                  
                }, 100);
                
              } else {
                price.innerHTML = '';
              }
            })
          }
          // update the title for selected product 
          if (document.querySelector('.title-container')) {
            document.querySelectorAll('.title-container').forEach(titleContainer => {
              if (! titleContainer.querySelector('.title-area')) {
                return;
              }
              var title = titleContainer.querySelector('.title-area');
              if (titleContainer.querySelector('[data-variant-id="' + product.dataset.productId + '"]')) {
                title.innerHTML = titleContainer.querySelector('[data-variant-id="' + product.dataset.productId + '"]').innerHTML;
              } else {
                title.innerHTML = '';
              }
              // change the URL to match the product location
              if (product.dataset.productTitle && product.dataset.productUrl) {
                // append to the current parameters set 
                var productUrl = product.dataset.productUrl;
                var currentUrl = new URL(window.location);
                if (currentUrl.searchParams.has('filter')) {
                  productUrl = new URL(product.dataset.productUrl, currentUrl.origin);
                  productUrl.searchParams.set('filter',currentUrl.searchParams.get('filter'));
                } 

                if(product.dataset.originalProductId) {
                  syncAftershipProductId(product.dataset.originalProductId);
                }

                document.title = product.dataset.productTitle ?? 'Title';
                window.history.replaceState({"pageTitle":document.title}, '', productUrl.toString());
              }
            })
          }
          // update the aftership estimate
          if (document.querySelector('.aftership-edd-container')) {
            document.querySelectorAll('.aftership-edd-container').forEach(asContainer => {
              var asfArea = asContainer.querySelector('#afs-area');
              if (!asfArea) {
                return;
              }
              var afsContent = asContainer.querySelector('[data-variant-id="' + product.dataset.productId + '"]');
              if (afsContent) {
                // Skip re-rendering when the same variant is already shown. Re-setting
                // innerHTML re-instantiates the <aftership-aedd> web component, which re-runs
                // its connectedCallback/fetch and can throw "[EddWidget] init error". No need
                // to pay that cost (or risk that error) when nothing changed.
                if (asfArea.dataset.afsVariant === product.dataset.productId) {
                  return;
                }
                asfArea.innerHTML = afsContent.innerHTML;
                asfArea.dataset.afsVariant = product.dataset.productId;
                syncAftershipProductId(product.dataset.originalProductId);
                // extract the product and update the section accordingly
                if (afsContent.dataset.aftershipProduct) {
                  window._asProduct = JSON.parse(decodeURI(afsContent.dataset.aftershipProduct));
                }
              } else {
                // No template for this variant — clear any previously rendered widget.
                asfArea.innerHTML = '';
                asfArea.dataset.afsVariant = '';
              }
            })
          }
          // update lowstock indicator
          if (document.querySelector('.variant-lowstock-container')) {
            document.querySelectorAll('.variant-lowstock-container').forEach(lowstockContainer => {
              if (! lowstockContainer.querySelector('.variant-lowstock-area')) {
                return;
              }
              var lowstock = lowstockContainer.querySelector('.variant-lowstock-area');
              if (lowstockContainer.querySelector('[data-variant-id="' + product.dataset.productId + '"]')) {
                lowstock.innerHTML = lowstockContainer.querySelector('[data-variant-id="' + product.dataset.productId + '"]').innerHTML;
              } else {
                lowstock.innerHTML = '';
              }
            })
          }
          // update upc metafield
          if (document.querySelector('.upc-section')) {
            document.querySelectorAll('.upc-section').forEach(upcSection => {
              if (! upcSection.querySelector('.upc-area')) {
                return;
              }
              var upcArea = upcSection.querySelector('.upc-area');
              if (upcSection.querySelector('[data-variant-id="' + product.dataset.productId + '"]')) {
                upcArea.innerHTML = upcSection.querySelector('[data-variant-id="' + product.dataset.productId + '"]').innerHTML;
              } else {
                upcArea.innerHTML = '';
              }
            })
          }
          // update product labels
          if (document.querySelector('.product-label-section')) {
            document.querySelectorAll('.product-label-section').forEach(labelSection => {
              const labelArea = labelSection.querySelector('.product-label-area');
              if (!labelArea) return;

              // find the label container for this variant
              const sourceLabel = labelSection.querySelector(
                '.product-label-container[data-variant-id="' + product.dataset.productId + '"]'
              );

              // clear the visible area
              labelArea.innerHTML = '';

              if (sourceLabel) {
                // clone the whole container so we keep all classes/styles
                const clone = sourceLabel.cloneNode(true);

                // make sure the visible one is not hidden
                clone.style.removeProperty('display'); // or: clone.style.display = '';

                // insert it back into the visible area
                labelArea.appendChild(clone);
              }
            });
          }
          // update the custom accordion section
          if (document.querySelector('.custom-accordion-content')) {
            let isCustomAccordionOpen = false;
            document.querySelectorAll('.custom-accordion-content').forEach(ccAccordion => {
              if (! document.querySelector('.custom-accordion-output')) {
                return;
              }
              var accordionArea = document.querySelector('.custom-accordion-output');
              // determine if the accordion is currently open
              if (accordionArea.querySelector('.is-open') && accordionArea.querySelector('.is-open').hasAttribute('open')) {
                isCustomAccordionOpen = true;
              }
              if (ccAccordion.querySelector('[data-variant-id="' + product.dataset.productId + '"]')) {
                accordionArea.innerHTML = ccAccordion.querySelector('[data-variant-id="' + product.dataset.productId + '"]').innerHTML;
                if (accordionArea.querySelector('.cc-accordion')) {
                  accordionArea.querySelector('.cc-accordion').classList.add('cc-initialized');
                }
                if (isCustomAccordionOpen && accordionArea.querySelector('.cc-accordion-item')) {
                  accordionArea.querySelector('.cc-accordion-item').classList.add('is-open');
                  accordionArea.querySelector('.cc-accordion-item').setAttribute('open', '');
                }
                accordionArea.addEventListener('click', function() {
                  let self = this;
                  self.querySelector('.cc-accordion-item').classList.toggle('is-open');
              });
              } else {
                accordionArea.innerHTML = '';
              }
            })
          }
          if (document.querySelector('.description-container')) {
            document.querySelectorAll('.description-container').forEach(descriptionContainer => {
              if (! descriptionContainer.querySelector('.description-area')) {
                return;
              }
              var description = descriptionContainer.querySelector('.description-area');
              if (descriptionContainer.querySelector('[data-variant-id="' + product.dataset.productId + '"]')) {
                description.innerHTML = descriptionContainer.querySelector('[data-variant-id="' + product.dataset.productId + '"]').innerHTML;
              } else {
                description.innerHTML = '';
              }
            })
          } 
          if (document.querySelector('.buy-container')) {
            document.querySelectorAll('.buy-container').forEach(buyContainer => {
              const buyTemplate = buyContainer.querySelector('[data-variant-id="' + product.dataset.productId + '"]');
              if (!buyTemplate) {
                return;
              }

              // Prefer replacing an existing .buy-area. If none was rendered on first paint
              // (e.g. prior variant-id mismatch), mount into .description-area or the container.
              const buyArea = buyContainer.querySelector('.buy-area');
              const buyParent = buyArea
                ? buyArea.parentElement
                : (buyContainer.querySelector('.description-area') || buyContainer);

              if (buyArea && buyParent.contains(buyArea)) {
                buyParent.removeChild(buyArea);
              }
              buyParent.innerHTML += buyTemplate.innerHTML;

              // reset any notification links
              const modalLinks = document.querySelectorAll('.modalLink');
              const closeModalLinks = document.querySelectorAll('.cc-popup-close-gg');
              const closeModalLinksViaBG = document.querySelectorAll('.cc-popup-background');

              for (let i = 0; i < modalLinks.length; i++) {
                modalLinks[i].addEventListener('click', () => {
                  if (typeof document.getElementById(closeModalLinks[i].dataset.modalclose != 'undefined')) {
                    document.getElementById(modalLinks[i].dataset.modal).classList.add('cc-popup--visible');
                  }
                });
              }

              for (let i = 0; i < closeModalLinks.length; i++) {
                closeModalLinks[i].addEventListener('click', () => {
                  if (typeof document.getElementById(closeModalLinks[i].dataset.modalclose != 'undefined')) {
                    document.getElementById(closeModalLinks[i].dataset.modalclose).classList.remove('cc-popup--visible');
                  }
                });
              }

              for (let i = 0; i < closeModalLinksViaBG.length; i++) {
                closeModalLinksViaBG[i].addEventListener('click', () => {
                  if (typeof document.getElementById(closeModalLinksViaBG[i].dataset.modalclose != 'undefined')) {
                    document.getElementById(closeModalLinksViaBG[i].dataset.modalclose).classList.remove('cc-popup--visible');
                  }
                });
              }
            });
          } 
          if (product.dataset.originalProductId) {
            window.currentProductId = product.dataset.originalProductId;
          }

          if (document.querySelector('#nugget-pdp-desktop-gallery') && ! document.querySelector('#nugget-pdp-desktop-gallery').classList.contains('js-hidden')) {
            window.activateStandardImageGallery(product.dataset.productId);
            window.currentVariantId = product.dataset.productId;
          } else {
            activatePdpMainSlider(product.dataset.productId);
            window.currentVariantId = product.dataset.productId;
            updateArrows();   
          }


          if (document.querySelector('[id^=nugget-pdp-slider-thumbnails]') && typeof pdpMainSlider == 'object') {
            // cleanup the image objects
            document.querySelectorAll('[id^=nugget-pdp-slider-thumbnails]').forEach((slide, index) => {
              // hide all slides that do not match the product
              slide.style.display = 'none';
              if (slide.dataset.productId != null && slide.dataset.variantId == product.dataset.productId) {
                slide.style.display = 'flex';
                if (typeof pdpMainThumbnailSlider[slide.dataset.productId] != 'undefined') {
                  var s = pdpMainThumbnailSlider[slide.dataset.productId];
                  if (pdpMainThumbnailVertical == true) {
                    s.update({ 
                      loop: false,
                          initial: 0,
                          slides: {
                            perView: 5,
                            spacing: 15,
                          },
                          vertical: true
                        }, 0
                      );
                  } else {
                    s.update({ 
                      loop: false,
                          initial: 0,
                          slides: {
                            perView: 5,
                            spacing: 15,
                          },
                        }, 0
                      );
                  }
                    s.slides.forEach((thumbnailSlide, thumbnailIndex) => {
                      if (thumbnailIndex == 0) {
                        thumbnailSlide.classList.add('active');
                      } else {
                        thumbnailSlide.classList.remove('active');
                      }
                    });                  
                }
              } 
            });
          }
          if (document.querySelector('[id^=nugget-pdp-slider-dots]') && typeof pdpMainSlider == 'object') {
            // cleanup the image objects
            document.querySelectorAll('[id^=nugget-pdp-slider-dots]').forEach((slide, index) => {
              // hide all slides that do not match the product
              slide.style.display = 'none';
              if (slide.dataset.productId != null && slide.dataset.variantId == product.dataset.productId) {
                slide.style.display = 'flex';
                if (typeof pdpMainDotsSlider[slide.dataset.productId] != 'undefined') {
                  var s = pdpMainDotsSlider[slide.dataset.productId];
                  s.update({ 
                    loop: false,
                        initial: 0,
                        drag:false,
                        slides: {
                          perView: 'auto',
                          spacing: 0,
                        },
                      }, 0
                    );
                    s.slides.forEach((dotSlide, dotIndex) => {
                      if (dotIndex == 0) {
                        dotSlide.classList.add('active');
                      } else {
                        dotSlide.classList.remove('active');
                      }
                    });                  
                }
              } 
            });
          }

          if (!product.classList.contains('embroidery-picker')) {
            const embroiderySwatch = document.querySelector(
              `.embroidery__wrapper .js-toggle-popup-info#${product.id}`
            );
            if (embroiderySwatch) {
              skipPdpLoaderHandler = true;
              embroiderySwatch.click();
              skipPdpLoaderHandler = false;
            }
          }
        });
      });    
    }
  }

  customElements.define("collection-pdp-loader", CollectionPdpLoader);
}